import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { IReportConfigEntry } from '../custom_text_interface';

export type ProgressReportsConfigModel = ITypedModel<IReportConfigEntry>;

angular.module('data-ng-custom-text').factory('ngProgressReportsConfigModel', () => {
  return new Model<IReportConfigEntry>({
    is_active: null,
    last_enabled_dt: '',
    name: '',
    nk: ''
  });
});



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/models/progress_reports_config_model.ts